export const initialVehicleForm = {
  name: "",
  fuelType: "",
  fuelTankCapacity: "",
  images: [],
  specifications: {
    transmission: "",
    seatingCapacity: "",
    hasDriver: false,
    airConditioned: true,
  },
  features: [],
  packages: [],
  // price: "",
  stock: "",
};

export const normalizeVehicles = (data) => {
  if (Array.isArray(data)) return data;
  return data?.vehicles || data?.items || [];
};

export const filterVehicles = (vehicles, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return vehicles;

  return vehicles.filter((vehicle) => {
    const name = vehicle?.name?.toLowerCase() || "";
    const fuelType = vehicle?.fuelType?.toLowerCase() || "";

    return (
      name.includes(term) ||
      fuelType.includes(term)
    );
  });
};

export const getVehicleStatusBadgeClass = (status) => {
  if (status === "available") return "badge bg-success";
  if (status === "booked") return "badge bg-primary";
  if (status === "maintenance") return "badge bg-warning text-dark";
  return "badge bg-secondary";
};


export const mapVehicleToForm = (vehicle) => ({
  name: vehicle?.name || "",
  fuelType: vehicle?.fuelType || "",
  fuelTankCapacity: vehicle?.fuelTankCapacity ? String(vehicle.fuelTankCapacity) : "",
  images: Array.isArray(vehicle?.images)
    ? vehicle.images.map((image) => ({
        url: image?.url || "",
        type: image?.type || "exterior",
      }))
    : [],
  specifications: {
    transmission: vehicle?.specifications?.transmission || "",
    seatingCapacity: vehicle?.specifications?.seatingCapacity
      ? String(vehicle.specifications.seatingCapacity)
      : "",
    hasDriver: Boolean(vehicle?.specifications?.hasDriver),
    airConditioned:
      vehicle?.specifications?.airConditioned === undefined
        ? true
        : Boolean(vehicle.specifications.airConditioned),
  },
  features: Array.isArray(vehicle?.features)
    ? vehicle.features.map((feature) => String(feature || ""))
    : [],
  packages: Array.isArray(vehicle?.packages)
    ? vehicle.packages.map((pkg) => ({
        description: pkg?.description || "",
        amount: pkg?.amount ? String(pkg.amount) : "",
      }))
    : [],
  // price: vehicle?.price ? String(vehicle.price) : "",
  stock: vehicle?.stock ? String(vehicle.stock) : "",
});

export const validateVehicleForm = (form) => {
  const errors = {};

  if (!form.name.trim()) {
    errors.name = "Vehicle name is required.";
  }

  // if (!form.price || Number(form.price) <= 0) {
  //   errors.price = "Price must be greater than 0.";
  // }

  if (form.stock && Number(form.stock) < 0) {
    errors.stock = "Stock cannot be negative.";
  }

  if (form.fuelTankCapacity && Number(form.fuelTankCapacity) < 0) {
    errors.fuelTankCapacity = "Fuel tank capacity cannot be negative.";
  }

  if (form.specifications.seatingCapacity && Number(form.specifications.seatingCapacity) <= 0) {
    errors["specifications.seatingCapacity"] = "Seating capacity must be greater than 0.";
  }

  form.images.forEach((image, index) => {
    if (image.url && !image.type) {
      errors[`images.${index}.type`] = "Image type is required when URL is provided.";
    }
  });

  form.packages.forEach((pkg, index) => {
    if (!pkg.description.trim()) {
      errors[`packages.${index}.description`] = "Package description is required.";
    }
    if (!pkg.amount || Number(pkg.amount) <= 0) {
      errors[`packages.${index}.amount`] = "Package amount must be greater than 0.";
    }
  });

  return errors;
};

export const buildVehiclePayload = (form) => {
  const images = form.images
    .filter((image) => image.url.trim())
    .map((image) => ({
      url: image.url.trim(),
      type: image.type || "exterior",
    }));

  const features = form.features
    .map((feature) => feature.trim())
    .filter(Boolean);

  const packages = form.packages
    .filter((pkg) => pkg.description.trim() && pkg.amount)
    .map((pkg) => ({
      description: pkg.description.trim(),
      amount: Number(pkg.amount),
    }));

  return {
    name: form.name.trim(),
    fuelType: form.fuelType || undefined,
    fuelTankCapacity: form.fuelTankCapacity ? Number(form.fuelTankCapacity) : undefined,
    images,
    specifications: {
      transmission: form.specifications.transmission || undefined,
      seatingCapacity: form.specifications.seatingCapacity
        ? Number(form.specifications.seatingCapacity)
        : undefined,
      hasDriver: Boolean(form.specifications.hasDriver),
      airConditioned: Boolean(form.specifications.airConditioned),
    },
    features,
    packages,
    // price: Number(form.price),
    stock: form.stock ? Number(form.stock) : 0,
  };
};

export const resolveFleetImaageUrl = (url) => {
  if (!url) return undefined
  if (url.startsWith("http") || url.startsWith("https")) return url;
  return `https://fleet-apis.tdcp.gop.pk${url}`;
}